import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface InitialInspectionProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const InitialInspection: React.FC<InitialInspectionProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [initialInspection, set_initialInspection] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Property Cost']?.['Initial Inspection'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Property Cost': { ...b.values?.['Property Cost'], 'Initial Inspection': v } } })
    );
    const label = 'Initial Inspection';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(initialInspection)}
                />
            ) : (
                <MoneyBox
                    id={'initialInspection'}
                    allowNegative={false}
                    value={initialInspection}
                    onChange={(value) => set_initialInspection(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
